import React, { useEffect, useState, useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { SyncQueueItem } from '@/core/offline/types/database.types'
import { useSyncContext } from '@/core/offline/contexts/SyncContext'

export function useSyncDashboard() {
  const { enqueueSnackbar } = useSnackbar()
  const { syncStatus, sync, retryFailedItems, clearCompletedItems, clearAllOfflineData, updateSyncStatus, getQueueItems } = useSyncContext()

  const [queueItems, setQueueItems] = useState<SyncQueueItem[]>([])
  const [loading, setLoading] = useState(false)

  const refreshData = useCallback(async () => {
    setLoading(true)
    try {
      await updateSyncStatus()
      const items = await getQueueItems()
      setQueueItems(items)
    } catch (error) {
      console.error('Failed to refresh sync data:', error)
    } finally {
      setLoading(false)
    }
  }, [updateSyncStatus, getQueueItems])

  useEffect(() => {
    refreshData()
    const interval = setInterval(refreshData, 5000)
    return () => clearInterval(interval)
  }, [refreshData])

  const handleAction = async (action: () => Promise<any>, successMessage: string, errorMessage: string) => {
    setLoading(true)
    try {
      await action()
      await refreshData()
      enqueueSnackbar(successMessage, { variant: 'success' })
    } catch (error) {
      console.error(errorMessage, error)
      enqueueSnackbar(errorMessage, { variant: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return {
    queueItems,
    loading,
    handleAction,
    syncStatus,
    sync,
    retryFailedItems,
    clearCompletedItems,
    clearAllOfflineData,
    refreshData,
  }
}
